export const DEBATE_FORMATS_META = [
  {
    id: '1v1',
    format: '1 vs 1',
    style: 'Formal/Simple',
    structure: 'Turn-based',
    bestFor: 'Quick matches, judgment',
    description: 'A traditional two-person structured argument where each participant takes alternating turns to present and refute.',
    usedIn: 'Online debates, informal academic challenges',
    features: [
      'Equal speaking time',
      'Rebuttal rounds',
      'Winner via score/judging'
    ]
  },
  {
    id: 'parliamentary',
    format: 'Parliamentary Debate',
    style: 'Formal/Team',
    structure: '4+ speakers',
    bestFor: 'Fast-paced tournaments',
    description: 'Fast-paced format based on British Parliament, with teams representing Government and Opposition.',
    usedIn: 'World Universities Debating Championships (WUDC), BP format',
    features: [
      'Opening/Closing Government vs Opposition',
      'Points of Information (POIs)',
      'Strict 7-minute speeches'
    ]
  },
  {
    id: 'ld',
    format: 'Lincoln-Douglas',
    style: 'Formal/Value',
    structure: '1v1',
    bestFor: 'Ethical/philosophical topics',
    description: 'One-on-one values-based debate, emphasizing logic, ethics, and philosophy.',
    usedIn: 'US high schools (NSDA)',
    features: [
      'Philosophical/ethical topics',
      'Long constructive speeches',
      'Cross-examination'
    ]
  },
  {
    id: 'policy',
    format: 'Policy Debate',
    style: 'Technical/Team',
    structure: '2v2',
    bestFor: 'Research-heavy competition',
    description: 'Two teams argue over proposed policy change using research, speed (spreading), and evidence.',
    usedIn: 'High school and collegiate competition (NSDA, NDT)',
    features: [
      'Heavy research + evidence',
      'Plan vs counterplan strategy',
      'Technical language'
    ]
  },
  {
    id: 'pf',
    format: 'Public Forum',
    style: 'Public/Team',
    structure: '2v2',
    bestFor: 'Accessible topics',
    description: 'Team debate focused on current events and public accessibility. Emphasis on persuasion and clarity.',
    usedIn: 'NSDA and public formats',
    features: [
      'Lay audience-friendly',
      'Crossfire questioning',
      'Team collaboration'
    ]
  },
  {
    id: 'oxford',
    format: 'Oxford-Style',
    style: 'Structured/Formal',
    structure: '2 sides',
    bestFor: 'Audience engagement',
    description: 'Structured, formal debate with audience vote before/after to determine winner.',
    usedIn: 'Intelligence Squared debates',
    features: [
      'Motion-based ("This House believes...")',
      'Audience voting pre/post',
      'Moderator guides Q&A'
    ]
  },
  {
    id: 'forum',
    format: 'Forum / Open Debate',
    style: 'Open/Informal',
    structure: 'Asynchronous',
    bestFor: 'Social platforms',
    description: 'Comment-based format where multiple participants contribute asynchronously or in free-form style.',
    usedIn: 'Reddit debates, online forums',
    features: [
      'No fixed turns',
      'Discussion-based',
      'Asynchronous contribution'
    ]
  },
  {
    id: 'cx',
    format: 'Cross-Examination (CX)',
    style: 'Formal/Team',
    structure: '2v2',
    bestFor: 'Strategic questioning',
    description: 'Traditional team format with formal cross-examinations after speeches.',
    usedIn: 'Competitive circuits in the US',
    features: [
      'Formal structure',
      'Strategic questioning phase',
      'Evidence-based argument'
    ]
  },
  {
    id: 'mace',
    format: 'Mace Debate',
    style: 'Formal',
    structure: '2v2',
    bestFor: 'UK debate circuits',
    description: 'British-based style similar to Oxford but with more controlled speaking rules.',
    usedIn: 'UK schools/universities',
    features: [
      'No POIs',
      'Emphasis on rhetoric',
      'Structured format'
    ]
  },
  {
    id: 'townHall',
    format: 'Town Hall',
    style: 'Public/Informal',
    structure: 'Flexible',
    bestFor: 'Community issues',
    description: 'Informal debate involving public questions and less rigid structure.',
    usedIn: 'Political events, local discussions',
    features: [
      'Audience interaction',
      'Spontaneous Q&A',
      'Moderator guided'
    ]
  },
  {
    id: 'fishbowl',
    format: 'Fishbowl',
    style: 'Interactive',
    structure: 'Rotating',
    bestFor: 'Educational settings',
    description: 'Interactive debate where a few speakers debate in the "fishbowl" and others observe or rotate in.',
    usedIn: 'Classrooms, workshops',
    features: [
      'Rotating participants',
      'Active listening focus',
      'Inclusive format'
    ]
  },
  {
    id: 'spar',
    format: 'Spontaneous Argumentation (SPAR)',
    style: 'Impromptu',
    structure: '1v1',
    bestFor: 'Debate warm-ups',
    description: 'Quick, impromptu format with minimal prep time.',
    usedIn: 'Debate training, classrooms',
    features: [
      'Short prep',
      '2-3 minute rounds',
      'Randomized topics'
    ]
  },
  {
    id: 'team',
    format: 'Team Debate',
    style: 'Structured',
    structure: '2v2 or 3v3',
    bestFor: 'Classroom debates and team-based argument practice',
    description: 'Debate format where teams present structured constructive speeches, rebuttals, and closing summaries.',
    usedIn: 'Schools, debate clubs, training sessions',
    features: [
      'Multiple speakers per team',
      'Constructive speeches and rebuttals',
      'Team coordination and strategy',
      'Closing reply speeches'
    ]
  }
];
